import { Box, Cell, Image, Text, TextButton } from '@wix/design-system'
import React, { FC } from 'react'

import { dataHooks } from './WixIntrosBoxXL.dataHooks'
import s from './WixIntrosBoxXL.scss'

type OptionProps = {
  image: string
  handleClick: () => void
  index: number
  description?: {
    title: string
    subtitle: string
    url: string
    urlText: string
  }
}
export const Option: FC<OptionProps> = ({ image, handleClick, index, description }) => {
  return (
    <Cell span={6}>
      <div className={s.item} onClick={handleClick} data-hook={dataHooks.item({ index })}>
        <Image width="200px" src={image} transparent borderRadius="0" dataHook={dataHooks.image({ index })} />
      </div>
      {description && (
        <Box direction="vertical" textAlign="start" marginTop="SP3" paddingLeft="SP2" paddingRight="SP2">
          <Text weight="bold">{description.title}</Text>
          <Text>{description.subtitle}</Text>
          <TextButton skin="dark" underline="always" as="a" target="_blank" href={description.url}>
            {description.urlText}
          </TextButton>
        </Box>
      )}
    </Cell>
  )
}
